import { IconDefinition } from '../../types';

const ArrowRight: IconDefinition = {
  name: 'arrow-right',
  definition: {
    viewBox: '0 0 24 24',
    pathData:
      'M14.8575 12.3984L10.1127 17.8348C9.92339 18.0551 9.61727 18.0551 9.42796 17.8348L9.14198 17.5021C8.95267 17.2818 8.95267 16.9256 9.14198 16.7053L13.2625 12L9.14601 7.29467C8.9567 7.0744 8.9567 6.71822 9.14601 6.49795L9.43199 6.1652C9.6213 5.94493 9.92741 5.94493 10.1167 6.1652L14.8615 11.6016C15.0468 11.8219 15.0468 12.1781 14.8575 12.3984Z'
  }
};

export default ArrowRight;
